export default "__VITE_ASSET__Bf3ngdtr__"